var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5809_14652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2511 4.58289H12.9178C11.8348 4.58289 10.7962 5.01309 10.0305 5.77887C9.26468 6.54464 8.83447 7.58325 8.83447 8.66622V41.3329C8.83447 42.4159 9.26468 43.4545 10.0305 44.2202C10.7962 44.986 11.8348 45.4162 12.9178 45.4162H37.4178C38.5008 45.4162 39.5394 44.986 40.3052 44.2202C41.0709 43.4545 41.5011 42.4159 41.5011 41.3329V16.8329L29.2511 4.58289Z",
    stroke: "#4BA031",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2524 4.58289V16.8329H41.5024",
    stroke: "#4BA031",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.668457,
    y: 22.5,
    width: 29,
    height: 13,
    rx: 1,
    fill: "#4BA031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5385 32.5L9.02846 30.15L7.65846 32.5H6.07846L8.27846 28.98L6.04846 25.52H7.65846L9.16846 27.86L10.5285 25.52H12.1085L9.91846 29.03L12.1485 32.5H10.5385ZM14.6139 31.39H16.9139V32.5H13.2139V25.52H14.6139V31.39ZM20.2138 32.57C19.7271 32.57 19.2871 32.4867 18.8938 32.32C18.5071 32.1533 18.2004 31.9133 17.9738 31.6C17.7471 31.2867 17.6304 30.9167 17.6238 30.49H19.1238C19.1438 30.7767 19.2438 31.0033 19.4238 31.17C19.6104 31.3367 19.8638 31.42 20.1838 31.42C20.5104 31.42 20.7671 31.3433 20.9538 31.19C21.1404 31.03 21.2338 30.8233 21.2338 30.57C21.2338 30.3633 21.1704 30.1933 21.0438 30.06C20.9171 29.9267 20.7571 29.8233 20.5638 29.75C20.3771 29.67 20.1171 29.5833 19.7838 29.49C19.3304 29.3567 18.9604 29.2267 18.6738 29.1C18.3938 28.9667 18.1504 28.77 17.9438 28.51C17.7438 28.2433 17.6438 27.89 17.6438 27.45C17.6438 27.0367 17.7471 26.6767 17.9538 26.37C18.1604 26.0633 18.4504 25.83 18.8238 25.67C19.1971 25.5033 19.6238 25.42 20.1038 25.42C20.8238 25.42 21.4071 25.5967 21.8538 25.95C22.3071 26.2967 22.5571 26.7833 22.6038 27.41H21.0638C21.0504 27.17 20.9471 26.9733 20.7538 26.82C20.5671 26.66 20.3171 26.58 20.0038 26.58C19.7304 26.58 19.5104 26.65 19.3438 26.79C19.1838 26.93 19.1038 27.1333 19.1038 27.4C19.1038 27.5867 19.1638 27.7433 19.2838 27.87C19.4104 27.99 19.5638 28.09 19.7438 28.17C19.9304 28.2433 20.1904 28.33 20.5238 28.43C20.9771 28.5633 21.3471 28.6967 21.6338 28.83C21.9204 28.9633 22.1671 29.1633 22.3738 29.43C22.5804 29.6967 22.6838 30.0467 22.6838 30.48C22.6838 30.8533 22.5871 31.2 22.3938 31.52C22.2004 31.84 21.9171 32.0967 21.5438 32.29C21.1704 32.4767 20.7271 32.57 20.2138 32.57Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5809_14652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.668457 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIocn);
export default __webpack_public_path__ + "static/media/excel-iocn.108dca6b63308f546eafb9ddf842152d.svg";
export { ForwardRef as ReactComponent };